import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem,PrimeIcons} from 'primeng/api';

@Component({
  selector: 'app-create-job-request',
  templateUrl: './create-job-request.component.html',
  styleUrls: ['./create-job-request.component.scss']
})
export class CreateJobRequestComponent implements OnInit {

  products: Product[];
  items: MenuItem[];
  events1: any[];

  constructor(private productService: ProductService) { }

    ngOnInit() {
        this.productService.getProductsSmall().then(data => this.products = data);
        
        this.items = [
          {label: 'Menu'},
          {label: 'Menu Active'},
        ];

        this.events1 = [
          {
            
            class: "step-completed",
            iconclass:"step-completed-icon"
          },
          {
            class: "step-next",
            iconclass:"step-next-icon"
          },
          {
            class: "step-pending",
            iconclass:"step-pending-icon"
          }
        ];

    }

}
